import React, { useState, useEffect } from 'react'
import classes from '../../../../pages/Member/MemberPage.module.css'
import { Box, Title, Center, Loader, Text , Grid, Avatar, Group, HoverCard, Stack, Badge, Card } from '@mantine/core'
import { getAnnouncementList } from '../../../../services/announcement'
import { getImageFile } from '../../../../services/fileImage'
import dayjs from 'dayjs-ext'
import relativeTime from 'dayjs-ext/plugin/relativeTime'

dayjs.extend(relativeTime)

const LoadingQuestion = () => {
  return (
    <Box pos="relative"> 
      <Center mih={500} mx="auto">
        <Loader size="xl" />
      </Center>
    </Box>
  )
}

const AnnountcementProgram = ({ detailProgram }) => {
  const defaultParameter = {
    eventSchedule: detailProgram.eventSchedule.id,
    search: '',
    orderBy: 'createdAt',
    order: 'desc',
    skip: 0,
    take: 10
  }
  const [announcementList, setAnnouncementList] = useState([])
  const [loading, setLoading] = useState(true)
  // const [parameter, setParameter] = useState(defaultParameter)

  const handleGetAnnouncementList = async () => {
    setLoading(true)
    try {
      const response = await getAnnouncementList(defaultParameter)
      setAnnouncementList(response.data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handleGetAnnouncementList()
    // eslint-disable-next-line
  }, [])

  const mappingAnnouncement = (data) => {
    if (data.length > 0) {
      const remap = data.map((val, index) => {
        const innerHtmlDiscussion = { __html: val.content }
        return (
          <Box mb={30}>
          <Grid type="container" justify="flex-start" mb={12}>
            <Grid.Col span='content'>
              <Group>
                <HoverCard width={250} shadow="md" withArrow openDelay={200} closeDelay={400}>
                  <HoverCard.Target>
                    <Avatar size='md' src={val.user.image !== null ? getImageFile(val.user.image) : null} />
                  </HoverCard.Target>
                  <HoverCard.Dropdown>
                    <Group>
                      <Avatar size='md' src={val.user.image !== null ? getImageFile(val.user.image) : null} />
                      <Stack gap={5}>
                        <Text size="sm" fw={700} lineClamp={1} style={{ lineHeight: 1 }}>
                          {val.user.fullName}
                        </Text>
                        <Badge variant="light" color="red" size="xs" tt='capitalize'>{val.user.role.name}</Badge>
                      </Stack>
                    </Group>
                  </HoverCard.Dropdown>
                </HoverCard>
              </Group>
            </Grid.Col>
            <Grid.Col span={11}>
              <Card pos='relative' withBorder shadow="md" radius="md">
                <Card.Section withBorder inheritPadding py="xs">
                  <Group justify='space-between' align='start'>
                    <Box>
                      <Text fz={12} fw='600'>{val.title}</Text>
                    </Box>
                    <Group gap={4}>
                      <Text fz={12} c='dimmed'>{dayjs(val.createdAt).diff(new Date(), 'day') < -7 ? dayjs(dayjs(val.createdAt).format('YYYY-MM-DD')).fromNow() : dayjs(val.createdAt).format('DD MMMM YYYY')}</Text>
                    </Group>
                  </Group>
                </Card.Section>
                <Text fz={11} fw='600' mt={8}>{val.user.fullName}: </Text>
                <Box component='p' style={{ width: '100%', margin:'0px' }} className="ck-content" dangerouslySetInnerHTML={innerHtmlDiscussion} />
              </Card>
            </Grid.Col>
          </Grid>
        </Box>
        )
      })

      return remap

    } else {
      return (
        <Box ta='center' py={60}>
          <Text c="dark">Program ini belum memiliki pengumuman</Text>
        </Box>
      )
    }
  }
  return (
    <Box>
      <Title className={classes.titleHeader}>Pengumuman</Title>
      <Box my={30} px={40}>
        {loading ? (<Box mih={500} pos='relative'><LoadingQuestion /></Box>) : mappingAnnouncement(announcementList)}
      </Box>
    </Box>
    
  )
}

export default AnnountcementProgram